export default __webpack_public_path__ + "static/media/Wolf's Wristbands of the Bloody Fang.dd87ae24.jpg";